// =============================================================================
//  Copyright   : 2018 semantics GmbH
//  Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 156393 $
//  Purpose     : call import apis
// =============================================================================
// ---Third-party imports
import {put, takeEvery, take, call, actionChannel} from 'redux-saga/effects'

// ---Framework imports
import {has, get, size, range} from 'ldash'
import Api from 'uix/api'
import log from 'uix/logging'
import {buffers} from 'uix/sagas'
import {Actions} from 'uix/registries'

// ---Local imports
import {
  uploadFile,
  setUploadState,
  runUploadImportOnIds,
  analyzeUploadImportOnIds,
  setUploadImportJob,
  setAnalyzedImport,
} from './actions'

// ---Globals
function* _runUploadImportOnIds({payload}) {
  let {txid, uploadids} = payload
  let {data, error} = yield Api.post('/api/runImportOnIndexedUpload', {
    indexIds: uploadids.join(','),
  })
  if (data) {
    yield put(setUploadImportJob(txid, data.ojid))
  } else if (error) {
    yield put(Actions.errorNotification({error, header: 'Import Error'}))
  }
}

function* _analyzeUploadImportOnIds({payload}) {
  yield put(setAnalyzedImport(payload.key, null))
  let {data, error} = yield Api.post('/api/analyzeIndexedUpload', {
    indexIds: payload.uploadids.join(','),
  })
  if (data) {
    yield put(setAnalyzedImport(payload.key, data.packages))
  } else if (error) {
    yield put(Actions.errorNotification({error, header: 'Analyze Error'}))
  }
}

export const sagas = {
  runUploadImportOnIds: takeEvery(runUploadImportOnIds, _runUploadImportOnIds),
  analyzeUploadImportOnIds: takeEvery(analyzeUploadImportOnIds, _analyzeUploadImportOnIds),
}
